const options = [
  { to: '/', text: 'Home' },
  { to: '/about', text: 'About us' },
  { to: '/policy', text: 'Policy' },
  { to: '/contact', text: 'Contact' },
];

export default options;
